import { translate } from "./translate";

export function getPublicAssetUrl(fileName = ''){
    if (/^(?:https?:|data:|blob:)/i.test(fileName))
        return fileName;

    const normalizedFileName = String(fileName).replace(/^\/+/, '');
    const configuredBaseUrl = process.env.VUE_APP_BASE_URL;
    if (!configuredBaseUrl)
        return `/${normalizedFileName}`;

    return `${configuredBaseUrl.replace(/\/+$/, '')}/${normalizedFileName}`;
}

export function normalizeBase64Image(base64String = ''){
    const normalized = String(base64String).trim();
    if (!normalized || /^(?:https?:|data:|blob:)/i.test(normalized))
        return normalized;

    try {
        const decoded = atob(normalized);
        if (/^(?:iVBOR|\/9j\/|R0lGOD|UklGR)/.test(decoded))
            return decoded;
    } catch (error) {
        return normalized;
    }

    return normalized;
}

export function getBase64(base64String = '', pureBase64 = false, placeholderImg = 'img/logo-icon-jobifull.png'){
    if(base64String == '' || base64String == null){
        if(pureBase64)
            return getPublicAssetUrl(placeholderImg);
        return `url(${getPublicAssetUrl(placeholderImg)})`;
    }
    const normalizedImage = normalizeBase64Image(base64String);
    const source = /^(?:https?:|data:|blob:)/i.test(normalizedImage)
        ? normalizedImage
        : `data:image/png;base64,${normalizedImage}`;
    if(pureBase64)
        return source;
    return `url(${source})`;
}

export async function getOnPublicImagesUrl(fileName = '', defaultImage = 'img/logo-icon-jobifull.png'){
    let requestedUrl = getPublicAssetUrl(fileName);
    const result = await resourceExists(requestedUrl);
    if(result){
        return requestedUrl;
    }else{
        return getPublicAssetUrl(defaultImage);
    }
}

export function getOnPublic(fileName = ''){
    return getPublicAssetUrl(fileName);
} 

export async function resourceExists(url) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
    //   if(!response.ok)
    //     console.clear();
      return response.ok;
    } catch (error) {
      return false;
    }
}

export function isImageValid(file){
    let response = {
        status: false,
        message: 'error'
    }
    const allowedMimeTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!allowedMimeTypes.includes(file.type)) {
        response.message = translate('accepted formats are: JPEG, PNG and GIF', 'ucfirst');
        return response;
    }
    const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
    if (file.size > maxSizeInBytes) {
        response.message = translate('max allowed size is 2 MB', 'ucfirst');
        return response;
    }
    response.status = true;
    return response;
}
